export const SET_QUEUES = 'SET_QUEUES'
export const SET_QUEUES_SEARCH = 'SET_QUEUES_SEARCH'
export const RESET_QUEUES = 'RESET_QUEUES'
export const RESET_QUEUES_SEARCH = 'RESET_QUEUES_SEARCH'
